import { GoogleOAuthProvider } from '@react-oauth/google';
import AuftragMain from './AuftragMain';

/**
 * @author noone
 */
export default function AuftragMainWrapper() {
    const google_clientid = process.env.REACT_APP_GOOGLE_CLIENTID!;

    return (
        <GoogleOAuthProvider clientId={google_clientid} >
            <AuftragMain />
        </GoogleOAuthProvider>
    );

}

